import Vue from 'vue/dist/vue.min.js';
import store from './store';

const bookmarks = () => {

    let bookmarkItems = document.querySelectorAll('.bookmark-container');

    let bookmarkConstructor = (id) => {
        Vue.component('bookmark', {
            props: ['data'],
            data: function() {
                return {
                    isBookmarked: false,
                    id: null,
                    type: null
                }
            },
            computed: {
                saved: function() {
                    return store.state.favorites[`${this.type}`];
                }
            },
            watch: {
                saved: function() {
                    this.isBookmarked = this.saved.includes(this.id) ? true : false;
                }
            },
            methods: {
                handleBookmark() {
                    store.commit('updateFavorites', {
                        id: this.id,
                        type: this.type,
                        action: this.isBookmarked ? "remove" : "add"
                    });
                    store.dispatch('checkFavorites');
                }
            },
            mounted() {
                this.id = this.$refs.bookmark.dataset.productId ? this.$refs.bookmark.dataset.productId : this.$refs.bookmark.dataset.articleId ? this.$refs.bookmark.dataset.articleId : this.$refs.bookmark.dataset.documentId ? this.$refs.bookmark.dataset.documentId : this.$refs.bookmark.dataset.softwareId ? this.$refs.bookmark.dataset.softwareId : null;

                this.type = this.$refs.bookmark.dataset.productId ? "productId" : this.$refs.bookmark.dataset.articleId ? "articleId" : this.$refs.bookmark.dataset.documentId ? "documentId" : this.$refs.bookmark.dataset.softwareId ? "softwareId" : null;
                
                // console.log("saved",this.saved);

                this.isBookmarked = this.saved.includes(`${this.id}`) ? true : false;
            }
        });

        new Vue({
            el: `.bookmark-container-${id}`,
        }).$mount(`.bookmark-container-${id}`, true);
    }

    if (bookmarkItems.length > 0) {
        bookmarkItems.forEach((item, index) => {
            item.classList.add(`bookmark-container-${index}`);
            bookmarkConstructor(index);
        })
    }

}

export default bookmarks;